import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    FaLinkedin,
    FaLink,
    FaWhatsapp,
    FaShareAlt,
    FaFacebook,
    FaTwitter,
    FaMapMarkerAlt,
    FaCalendarAlt,
    FaChartLine,
} from "react-icons/fa";
import styles from "./BusinessCard.module.css";
import defaultIMG from "../../../Assets/defaultimg.png";
import Swal from "sweetalert2";
import { FaLock } from "react-icons/fa";
import {
    checkIfCompanyPaid,
    ContactcreditPricing,
    getMykohere,
    createRazorpayOrderContacts,
    handlePaymentSuccesscontacts,
} from "../../../Services/APIrequests";
import { useEffect } from "react";

// Module-level cache to avoid multiple identical API calls when many BusinessCard
// components mount at once. We keep a cached value and an in-flight promise.
let contactPricingCache = null;
let contactPricingPromise = null;
const BusinessCard = ({
    CIN,
    title,
    paid_up_capital,
    authorised_capital,
    pat,
    turn_over,
    reasonForSale,
    sale_price,
    business_image,
    url,
    location,
    date_of_incorporation,
    legal_entity,
    industry,
    isContact,
}) => {
    const navigate = useNavigate();
    const loca = useLocation();
    const [showShareOptions, setShowShareOptions] = useState(false);
    const [loading, setLoading] = useState(false);
    const [ShowPaidModal, setShowPaidModal] = useState(false);
    const [pricingData, setPricingData] = useState([]);

    const handleShareClick = (e) => {
        e.stopPropagation();
        setShowShareOptions(!showShareOptions);
    };
    useEffect(() => {
        let mounted = true;

        const loadPricing = async () => {
            try {
                // If we already have cached data, use it
                if (contactPricingCache) {
                    if (mounted) setPricingData(contactPricingCache);
                    return;
                }

                // If a fetch is already in progress, await it; otherwise start one
                if (!contactPricingPromise) {
                    contactPricingPromise = ContactcreditPricing()
                        .then((res) => {
                            contactPricingCache = res.data?.salesPricing;
                            contactPricingPromise = null;
                            return res;
                        })
                        .catch((err) => {
                            contactPricingPromise = null;
                            throw err;
                        });
                }

                const res = await contactPricingPromise;
                if (mounted) setPricingData(res.data?.salesPricing);
                console.log("fetching credit pricing:", res.data);
            } catch (error) {
                console.error("Error fetching credit pricing:", error);
            }
        };

        loadPricing();

        return () => {
            mounted = false;
        };
    }, []);

    const ContactCompany = async (CIN) => {
        let body = { companyId: CIN };
        try {
            let res = await checkIfCompanyPaid(body);
            setLoading(false);
            if (res?.data?.Status == 1) {
                navigate(`/ContactBusiness/${CIN}`);
            } else {
                /*   const result = await Swal.fire({
                            title: "Not enough credits",
                            text: "You don't have enough credits. Want to purchase?",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonText: "Purchase",
                            cancelButtonText: "Cancel",
                            reverseButtons: true,
                        });

                        if (result.isConfirmed) {
                            navigate("/kohere/mycredits", {
                                state: {
                                    from: `/ContactBusiness/${CIN}`,
                                    active: "ContactCredits",
                                },
                            });
                        } */
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    const handleSubscribe = async (
        razorpay_order_Id,
        razorpay_payment_id,
        credits
    ) => {
        try {
            const data2 = {
                razorpay_order_id: razorpay_order_Id,
                razorpay_payment_id: razorpay_payment_id,
                credits: credits,
            };

            const paymentCartDetailsApi1 = await handlePaymentSuccesscontacts(
                data2
            );

            if (paymentCartDetailsApi1.status === 200) {
                ContactCompany(CIN);
            } else {
                alert(
                    paymentCartDetailsApi1.message ||
                        "Something went wrong while processing the subscription."
                );
            }
        } catch (error) {
            console.error("Error in handleSubscribe:", error);
            alert("An unexpected error occurred. Please try again.");
        }
    };
    const handleContactClick = async (e, CIN) => {
        e.stopPropagation();
        const isTokenPresent = sessionStorage.getItem("token");
        let pricingItem = pricingData?.filter((item) => item.minCredits == 1);
        if (pricingItem.length > 0) {
            pricingItem = pricingItem[0];
        }
        if (isTokenPresent) {
            if (isContact == 1) {
                navigate(`/ContactBusiness/${CIN}`);
            } else {
                let contactCredits = 0;
                try {
                    const resp = await getMykohere(isTokenPresent);
                    contactCredits = resp?.data?.user?.contactCredits || 0;
                } catch (err) {
                    console.error("Failed to fetch user credits", err);
                }
                console.log(pricingData);
                const creditDisabled = contactCredits <= 0 ? "disabled" : "";
                Swal.fire({
                    title: `Contact ${title}`,
                    html: `
                                          <div style="font-family:inherit; text-align:left;">
                                              <div style="margin-bottom:10px; font-weight:600; color:#333;">Select Payment Method</div>
          
                                              <div style="display:flex; gap:12px; margin-bottom:14px;">
                                                  <label class="swal-unlock-label" data-value="pay" style="flex:1; border-radius:10px; padding:14px; display:flex; align-items:center; gap:12px; cursor:pointer; background:#fff; position:relative;">
                                                      <input id="swal-unlock-pay" type="radio" name="unlockOption" value="pay" style="display:none;" />
                                                      <div class="swal-unlock-check" style="width:36px;height:36px;border-radius:50%;background:var(--PrimaryColor);display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:18px;">✓</div>
                                                      <div>
                                                          <div  style="font-size:16px;color:var(--PrimaryColor);font-weight:600;">Pay ₹${
                                                              pricingItem?.pricePerCredit
                                                          }</div>
                                                          <div style="font-size:12px;color:var(--PrimaryColor);">One-time payment</div>
                                                      </div>
                                                   
                                                  </label>

                                                  <label class="swal-unlock-label" data-value="credit" style="flex:1; border:2px dashed #dcdcdc; border-radius:10px; padding:14px; display:flex; align-items:center; gap:12px; cursor:pointer; background:#fafafa; position:relative;">
                                                  
                                                      <div class="swal-unlock-check" style="width:36px;height:36px;border-radius:50%;background:var(--PrimaryColor);display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:18px;">✓</div>
                                                      <input id="swal-unlock-credit" type="radio" name="unlockOption" value="credit" ${creditDisabled} style="display:none;" />
                                                   
                                                      <div>
                                                          <div style="font-size:16px;color:#444;font-weight:600;">Pay using Credit</div>
                                                          <div style="font-size:12px;color:${
                                                              contactCredits <=
                                                              0
                                                                  ? "#d9534f"
                                                                  : "#999"
                                                          };">${
                        contactCredits <= 0
                            ? "No Credits Available"
                            : "Use 1 credit"
                    }</div>
                                                      </div>
                                                    
                                                  </label>
                                              </div>
          
                                              <div style="margin:14px 0;">
                                                  <button id="swal-buy-credits" style="background:var(--PrimaryColor);color:#fff;padding:12px 18px;border-radius:8px;border:none;box-shadow:0 6px 18px rgba(0,0,0,0.08);cursor:pointer;width:100%;">Unlock Attractive Prices & Single Click Purchasing Credits!</button>
                                              </div>
          
                                              <div style="margin-top:12px; font-size:13px; color:#333; text-align:left;">
                                                  <strong>Additional Information</strong>
                                                  <ul style="margin:8px 0 0 18px; color:#444;">
                                                      <li>View corporate profile for you view the year from a year from rom unlock date.</li>
                                                      <li>Prices shown exclusive of GST.</li>
                                                  </ul>
                                              </div>
                                          </div>
                                  `,
                    showCloseButton: true,
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText: "Proceed to Checkout",
                    cancelButtonText: "Cancel",
                    showLoaderOnConfirm: true,
                    didOpen: () => {
                        const buyBtn =
                            document.getElementById("swal-buy-credits");
                        if (buyBtn) {
                            buyBtn.addEventListener("click", () => {
                                // navigate to buy credits page
                                navigate("/kohere/mycredits", {
                                    state: {
                                        from: `/BusinessesforSale`,
                                        active: "ContactCredits",
                                    },
                                });
                                Swal.close();
                            });
                        }

                        // Wire up selectable labels so only one is highlighted at a time
                        const labels =
                            document.querySelectorAll(".swal-unlock-label");

                        function updateSelection(value) {
                            labels.forEach((lbl) => {
                                const input = lbl.querySelector(
                                    'input[name="unlockOption"]'
                                );
                                const check =
                                    lbl.querySelector(".swal-unlock-check");
                                if (!input) return;
                                if (lbl.dataset.value === value) {
                                    input.checked = true;
                                    lbl.style.boxShadow =
                                        "0 4px 14px rgba(0,0,0,0.08)";
                                    lbl.style.border =
                                        "2px solid var(--PrimaryColor)";
                                    if (check) check.style.display = "flex";
                                } else {
                                    input.checked = false;
                                    lbl.style.boxShadow = "none";
                                    if (lbl.dataset.value === "credit") {
                                        lbl.style.border = "2px dashed #dcdcdc";
                                    } else {
                                        lbl.style.border = "2px solid #dcdcdc";
                                    }
                                    if (check) check.style.display = "none";
                                }
                            });
                        }

                        labels.forEach((lbl) => {
                            lbl.addEventListener("click", (ev) => {
                                const input = lbl.querySelector(
                                    'input[name="unlockOption"]'
                                );
                                if (!input) return;
                                // Respect disabled attribute on input
                                if (input.disabled) return;
                                updateSelection(lbl.dataset.value);
                            });
                        });

                        // Set default selection: pay
                        updateSelection("pay");
                    },
                    preConfirm: async () => {
                        try {
                            const selected = document.querySelector(
                                'input[name="unlockOption"]:checked'
                            );
                            const val = selected ? selected.value : "pay";
                            if (val === "credit") {
                                // user chose to use credit — call unlock handler and wait
                                await ContactCompany(CIN);
                                return { used: "credit" };
                            } else {
                                // user chose to pay — create order and open Razorpay, wait for create order
                                let TotalPrice =
                                    Number(pricingItem?.pricePerCredit) +
                                    Number(pricingItem?.pricePerCredit * 0.18);

                                console.log(TotalPrice);
                                const roundedAmount = parseFloat(
                                    TotalPrice || 0
                                );

                                const paymentCartDetailsApi =
                                    await createRazorpayOrderContacts({
                                        amount: roundedAmount,
                                    });

                                if (paymentCartDetailsApi.status === 201) {
                                    const options = {
                                        key: process.env.REACT_APP_RAZORPAYKEY,
                                        amount: roundedAmount * 100,
                                        currency: "INR",
                                        name: "Kohere",
                                        description: "Order Payments",
                                        order_id:
                                            paymentCartDetailsApi.data
                                                .razorpay_orderId,
                                        handler: function (response) {
                                            if (
                                                response.razorpay_payment_id !==
                                                null
                                            ) {
                                                handleSubscribe(
                                                    paymentCartDetailsApi.data
                                                        .data.razorpay_orderId,
                                                    response.razorpay_payment_id,
                                                    1,
                                                    CIN
                                                );
                                            } else {
                                                alert(
                                                    "Something went wrong, please try again."
                                                );
                                            }
                                        },
                                        prefill: {
                                            name: "kohere",
                                            email: "kohere@gmail.com",
                                        },
                                        notes: { address: "" },
                                        theme: { color: "#FDFBB9" },
                                    };

                                    const rzp1 = new window.Razorpay(options);
                                    rzp1.open();
                                    return { used: "pay" };
                                } else {
                                    throw new Error("Failed to create order");
                                }
                            }
                        } catch (err) {
                            Swal.showValidationMessage(
                                `Request failed: ${err.message}`
                            );
                            throw err;
                        }
                    },
                });
            }
        } else {
            navigate("/login", { state: { from: loca.pathname } });
        }
    };

    const handleCardClick = (CIN) => {
        navigate(`/BusinessesforSale/${CIN}`);
    };

    const handleDetailsClick = (e, CIN) => {
        e.stopPropagation();
        navigate(`/BusinessesforSale/${CIN}`);
    };

    return (
        <div
            className={styles.businessCard}
            onClick={() => handleCardClick(CIN)}>
            {/* Card Image with Overlay Icons */}
            <div className={styles.cardImageContainer}>
                <img
                    src={business_image}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = defaultIMG;
                    }}
                    alt="Company"
                    className={styles.cardImage}
                />

                {/* Asking price badge on image */}
                <div
                    className={styles.priceBadge}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleDetailsClick(e, CIN);
                    }}>
                    <div className={styles.priceBadgeAmount}>
                        ₹{sale_price || "87.00"}
                    </div>
                    <div className={styles.priceBadgeLabel}>Asking Price</div>
                </div>

                {/* Featured Badge */}
                {/* <div className={styles.featuredBadge}>
          Featured
        </div> */}

                {/* Rating and Share Icons */}
                <div className={styles.topIcons}>
                    {/* <div className={styles.rating}>
            <span>⭐</span>
            <span>{rating || '4.5'}</span>
          </div> */}

                    <div className={styles.shareContainer}>
                        <button
                            className={styles.shareButton}
                            onClick={handleShareClick}>
                            <FaShareAlt />
                        </button>

                        {showShareOptions && (
                            <div className={styles.shareDropdown}>
                                <a
                                    href={`https://facebook.com/sharer/sharer.php?u=${window.location.origin}/BusinessesforSale/${CIN}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(e) => e.stopPropagation()}>
                                    <FaFacebook />
                                </a>
                                <a
                                    href={`https://twitter.com/intent/tweet?url=${window.location.origin}/BusinessesforSale/${CIN}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(e) => e.stopPropagation()}>
                                    <FaTwitter />
                                </a>
                                <a
                                    href={`https://www.linkedin.com/shareArticle?mini=true&url=${window.location.origin}/BusinessesforSale/${CIN}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(e) => e.stopPropagation()}>
                                    <FaLinkedin />
                                </a>
                                <a
                                    href={`https://wa.me/?text=${window.location.origin}/BusinessesforSale/${CIN}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(e) => e.stopPropagation()}>
                                    <FaWhatsapp />
                                </a>
                                {/* Copy Link */}
                                <a
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigator.clipboard.writeText(
                                            `${window.location.origin}/BusinessesforSale/${CIN}`
                                        );
                                        Swal.fire({
                                            icon: "success",
                                            title: "Copied!",
                                            text: "Link copied to clipboard",
                                            timer: 1500,
                                            showConfirmButton: false,
                                        });
                                    }}
                                    className={styles.copyLinkButton}>
                                    <FaLink />
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Card Content */}
            <div className={styles.cardContent}>
                {/* Company Title */}
                <h3 className={styles.companyTitle}>{title}</h3>

                {/* Description */}
                <p className={styles.description}>
                    {reasonForSale || "Leading business solutions provider..."}
                </p>

                {/* Location and Year */}
                <div className={styles.locationYear}>
                    <div className={styles.locationInfo}>
                        <FaMapMarkerAlt className={styles.icon} />
                        <span>
                            {location && location.length > 50
                                ? `${location.slice(0, 50)}...`
                                : location || "Location"}
                        </span>
                    </div>

                    {/* <div className={styles.yearInfo}>
            <FaCalendarAlt className={styles.icon} />
            <span>{year || "2015"}</span>
          </div> */}
                </div>

                {/* Employee and Turnover Info */}
                <div className={styles.businessInfo}>
                    <div className={styles.infoItem}>
                        <FaChartLine className={styles.icon} />
                        <span>
                            {turn_over || "₹15.50 Cr turn..."} Turn Over
                        </span>
                    </div>

                    <div className={styles.yearInfo}>
                        <FaCalendarAlt className={styles.icon} />
                        <span>
                            {date_of_incorporation
                                ? new Date(date_of_incorporation).getFullYear()
                                : "2015"}
                        </span>
                    </div>
                    {/* <div className={styles.infoItem}>
            <FaUsers className={styles.icon} />
            <span>{employees || "150-200 employ..."}</span>
          </div> */}
                </div>

                {/* Category and Company Type Tags */}
                <div className={styles.tags_div}>
                    <div className={styles.tags}>
                        <span className={styles.categoryTag}>
                            {Array.isArray(industry)
                                ? industry[0]
                                : industry || "Technology"}
                        </span>

                        <span className={styles.companyTypeTag}>
                            {legal_entity || "Private Limited Company"}
                        </span>
                    </div>
                </div>

                {/* Financial Details */}
                <div className={styles.financialDetails}>
                    <div className={styles.capitalInfo}>
                        <div className={styles.capitalItem}>
                            <span className={styles.label}>
                                Authorized Capital:
                            </span>
                            <span className={styles.value}>
                                {authorised_capital}
                            </span>
                        </div>
                        <div className={styles.capitalItem}>
                            <span className={styles.label}>
                                Paid Up Capital:
                            </span>
                            <span className={styles.value}>
                                {paid_up_capital}
                            </span>
                        </div>
                    </div>
                    <div className={styles.patInfo}>
                        <span className={styles.label}>PAT:</span>
                        <span className={styles.value}>{pat}</span>
                    </div>
                </div>

                {/* Price and Action Buttons */}
                <div className={styles.cardFooter}>
                    <div className={styles.actionButtons}>
                        <button
                            className={styles.detailsButton}
                            onClick={(e) => handleDetailsClick(e, CIN)}>
                            Details
                        </button>
                        <button
                            disabled={loading}
                            className={styles.contactButton}
                            onClick={(e) => handleContactClick(e, CIN)}>
                            {loading ? (
                                "Loading..."
                            ) : (
                                <>
                                    Contact{" "}
                                    {isContact == 0 && <FaLock size={10} />}
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BusinessCard;
